/**
 * Table Sorting Functionality
 * Handles sorting for data tables using data-title attributes
 */

export function initializeTableSorting() {
	const sortableElements = document.querySelectorAll('.sortable');

	sortableElements.forEach(element => {
		// Make headers focusable for keyboard navigation
		element.setAttribute('tabindex', '0');
		element.style.cursor = 'pointer';

		// Add click event listener
		element.addEventListener('click', function (e) {

			e.preventDefault();
			e.stopPropagation();

			// Get the data-title directly from the th element
			const dataTitle = this.getAttribute('data-title');

			if (dataTitle) {
				applySortingToUrl(dataTitle);
			}
		});

	});
}

function applySortingToUrl(dataTitle) {
	let url = new URL(window.location);
	let currentSort = url.searchParams.get('sort');
	let currentOrder = url.searchParams.get('order');

	let newOrder = 'asc';

	// If clicking the same column, toggle the order
	if (currentSort === dataTitle) {
		newOrder = currentOrder == 'asc' ? 'desc' : 'asc';
	}

	// Update URL parameters
	url.searchParams.set('sort', dataTitle);
	url.searchParams.set('order', newOrder);


	// Update the URL and reload to apply sorting
	window.location.href = url.toString();
}